import { useEffect } from 'react';
import { useMsal } from '@azure/msal-react';
import { initAperture, getClient } from '../lib/aperture';

export function ApertureProvider({ children }: { children: React.ReactNode }) {
  const { accounts } = useMsal();
  const account = accounts[0] ?? null;

  useEffect(() => {
    initAperture();
  }, []);

  // Auto-identify when Entra ID user is available
  // account.localAccountId is the Entra OID (GUID),
  // account.name is display name, account.username is UPN/email
  useEffect(() => {
    if (account) {
      getClient()?.identify(account.localAccountId, {
        name: account.name ?? '',
        email: account.username ?? '',
      });
    }
  }, [account]);

  return <>{children}</>;
}
